

export class FamilyProjectRequestModel{
    projectName: string;
    originalSourceType: string;
    individualGivenName: string;
    individualLastName: string;
    individualGender: string;
}